// NPM Imports
import React, { Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Loader } from "@revvsales/components";

// Components Imports
import DropzoneFiles from "../../../../commonComponents/DropzoneFiles";

// Actions Imports
import { forceUpdateEditorSectionIdAction } from "../../../../actions/DocumentActions/index";

// Services Imports
import {
  uploadImageService,
  uploadSharedDocumentAttachmentService,
} from "../../../../actions/DocumentActions/services";

// Internal Imports
import {
  MAX_IMAGE_HEIGHT,
  MAX_IMAGE_WIDTH,
} from "../../../../constants/images";
import IMAGE_FIELD_ICON from "../../../../assets/attachment-icons/jpg.svg";

// Destructuring
// const { DOCUMENT_COMPONENT_TYPES } = DOCUMENTS;

function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) {
    return "0 Bytes";
  }
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  // eslint-disable-next-line no-restricted-properties
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}

class ImageFormField extends Component {
  state = {
    errMsg: null,
    loading: false,
    uploadedImage: null,
  };

  componentDidMount() {
    this._setDefaultValue();
  }

  _setDefaultValue = () => {
    if (this.props.value) {
      this.setState({ uploadedImage: this.props.value });
    }
  };

  _fileListToArray = (list, event) => {
    const array = [];
    if (event.target) {
      for (let i = 0; i < list.length; i += 1) {
        array.push(list.item(i));
      }
    } else {
      array.push(list);
    }
    return array;
  };

  _getImageDimension = data =>
    new Promise(res => {
      if (data instanceof Array) {
        const file = new FileReader();
        const img = new Image();
        img.onload = () => {
          const newDimensions = this._reduceDimensions(img.width, img.height);
          res(newDimensions);
        };
        file.onload = () => {
          img.src = file.result;
        };
        file.readAsDataURL(data[0]);
      } else {
        const img = new Image();
        img.onload = () => {
          const newDimensions = this._reduceDimensions(img.width, img.height);
          res(newDimensions);
        };
        img.src = data;
      }
    });

  _reduceDimensions = (width, height) => {
    // reduce the dimensions if it exceeds max limit
    let newDimensions = { width, height };
    if (width > MAX_IMAGE_WIDTH) {
      newDimensions = {
        width: MAX_IMAGE_WIDTH,
        height: MAX_IMAGE_WIDTH * (height / width),
      };
    }
    if (height > MAX_IMAGE_HEIGHT) {
      newDimensions = {
        height: MAX_IMAGE_HEIGHT,
        width: MAX_IMAGE_HEIGHT * (width / height),
      };
    }
    return newDimensions;
  };

  _updateUploadedImage = (uploadImgLink, fileItems, imgHeight, imgWidth) => {
    let tempImgJustify = "flex-start";
    let tempAltText = "";
    if (
      this.props.metaData &&
      this.props.metaData.default &&
      !this._isBase64(this.props.metaData.default)
    ) {
      const { imgJustify, altText } = JSON.parse(this.props.metaData.default);
      tempImgJustify = imgJustify;
      tempAltText = altText;
    }
    const imageData = JSON.stringify({
      image: uploadImgLink,
      imgWidth,
      imgHeight,
      imgJustify: tempImgJustify,
      altText: tempAltText,
    });
    this.setState(
      {
        checkImgUploadLoader: false,
        loading: false,
        uploadedImage: {
          imageData,
          name: fileItems[0].name,
          size: fileItems[0].size,
        },
      },
      () => {
        this.props
          .updateDynamicFieldsInDoc(this.props.id, imageData)
          .then(() => {
            this._checkForUpdateField(imageData);
            this.props.forceUpdateEditorSectionIdAction(
              this.props.imageSecitonId,
            );
          })
          .catch(() => {});
      },
    );
  };

  _onUploadImage = fileItems => {
    // Case 1 :: if it is a case of image file upload
    if (typeof fileItems === "object" && fileItems instanceof Array) {
      if (fileItems.length > 0) {
        const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
        // Check if the uploaded file is an image of type jpeg, jpg or png
        if (allowedTypes.indexOf(fileItems[0].type) === -1) {
          this.setState({
            errMsg:
              "This file type is not supported. Try uploading .jpeg, .jpg or .png",
          });
        } else {
          this.setState({
            loading: true,
          });
          this._getImageDimension(fileItems).then(imgDetails => {
            // Shared document case
            if (this.props.isSharedDocument) {
              uploadSharedDocumentAttachmentService(
                this.props.docID,
                this.props.sharingHash,
                fileItems[0],
              )
                .then(res => {
                  this._updateUploadedImage(
                    res.Link,
                    fileItems,
                    imgDetails.height,
                    imgDetails.width,
                  );
                })
                .catch(error => {
                  console.error(
                    `ImageFormField => _onUploadImage => Error :`,
                    error,
                  );
                  this.setState({
                    errMsg: "Oops, Something went wrong!!",
                    loading: false,
                  });
                });
            }
            // Looged-in user document case
            else {
              uploadImageService(fileItems[0])
                .then(res => {
                  this._updateUploadedImage(
                    res.Image.Path,
                    fileItems,
                    imgDetails.height,
                    imgDetails.width,
                  );
                })
                .catch(error => {
                  console.error(
                    `ImageFormField => _onUploadImage =>  Error :`,
                    error,
                  );
                  this.setState({
                    errMsg: "Oops, Something went wrong!!",
                    loading: false,
                  });
                });
            }
          });
        }
      }
    }
    // Case 2 :: if it is a case of choosing image from "Unsplash"
    else if (typeof fileItems === "string") {
      this.setState({
        loading: true,
      });
      this._getImageDimension(fileItems).then(imgDetails => {
        let tempImgJustify = "flex-start";
        let tempAltText = "";
        if (
          this.props.metaData &&
          this.props.metaData.default &&
          !this._isBase64(this.props.metaData.default)
        ) {
          const { imgJustify, altText } = JSON.parse(
            this.props.metaData.default,
          );
          tempImgJustify = imgJustify;
          tempAltText = altText;
        }

        const imageData = JSON.stringify({
          image: fileItems,
          imgWidth: imgDetails.width,
          imgHeight: imgDetails.height,
          imgJustify: tempImgJustify,
          altText: tempAltText,
        });
        this.setState(
          {
            uploadedImage: {
              imageData,
              name: this.props.label,
            },
            loading: false,
          },
          () => {
            this.props
              .updateDynamicFieldsInDoc(this.props.id, imageData)
              .then(() => {
                this._checkForUpdateField(imageData);
                this.props.forceUpdateEditorSectionIdAction(
                  this.props.imageSecitonId,
                );
              })
              .catch(() => {});
          },
        );
      });
    } else {
      this.setState({
        errMsg: null,
        uploadedImage: null,
      });
    }
  };

  _deleteUploadedFile = () => {
    this.setState({ uploadedImage: null }, () => {
      this.props.updateDynamicFieldsInDoc(this.props.id, "");
      this._checkForUpdateField("");
    });
  };

  _checkForUpdateField = currentValue => {
    if (this.props.value !== currentValue) {
      this.props.updateField(this.props.id, currentValue);
      if (currentValue) {
        this.props.filledStatus(true);
      } else {
        this.props.filledStatus(false);
      }
    }
  };

  _getUploadImagePlaceholder = () => (
    <span className="imageformfield-upload-image-placeholder">
      <FontAwesomeIcon
        icon={["far", "upload"]}
        className="imageformfield-upload-image-placeholder-icon"
      />{" "}
      Drag & drop image files (or) <u> browse </u> to upload
    </span>
  );

  _isBase64 = imageString => {
    if (
      typeof imageString === "string" &&
      (imageString.startsWith("data") ||
        (imageString.startsWith("<") && imageString.includes("<img ")))
    ) {
      return true;
    }
    return false;
  };

  _isHtmlString = dataString => {
    if (dataString.startsWith("<p>") || dataString.startsWith("<img")) {
      return true;
    }
    return false;
  };

  _getBase64FromHtml = htmlString => {
    try {
      const parser = new DOMParser();
      const htmlDoc = parser.parseFromString(htmlString, "text/xml");
      const srcValue = htmlDoc.getElementsByTagName("img")[0].attributes.src
        .value;
      return srcValue;
    } catch (error) {
      return htmlString;
    }
  };

  render() {
    return (
      <div className="imageformfield-container">
        <div className="imageformfield-form-wrapper">
          {/* --------- Uploaded Image section --------- */}
          {this.state.uploadedImage ? (
            <div
              className={`imageformfield-uploaded-image-wrapper ${
                this.props.docIsLocked ? " locked-uoload-wrapper " : ""
              }`}>
              <div className="imageformfield-uploaded-image-icon-section">
                <img
                  src={IMAGE_FIELD_ICON}
                  className="imageformfield-uploaded-image-icon"
                  alt="attachment"
                />
              </div>
              <div className="imageformfield-uploaded-image-details-section">
                <div className="imageformfield-uploaded-image-label">
                  {this.state.uploadedImage.name
                    ? this.state.uploadedImage.name
                    : this.props.label}
                </div>
                <div className="imageformfield-uploaded-image-size">
                  {this.state.uploadedImage.size
                    ? formatBytes(this.state.uploadedImage.size)
                    : ""}
                </div>
              </div>
              <div
                className="imageformfield-uploaded-image-delete-section"
                onClick={
                  !this.props.docIsLocked ? this._deleteUploadedFile : () => {}
                }
                onKeyPress={() => {}}
                role="button"
                tabIndex="0">
                <FontAwesomeIcon
                  icon={["far", "trash-alt"]}
                  className="imageformfield-uploaded-image-delete-icon"
                />
              </div>
            </div>
          ) : (
            //  --------- Upload Image section ---------
            <div className="imageformfield-image-upload-wrapper">
              {this.props.docIsLocked ? (
                <div className="imageformfield-image-locked-upload-placeholder">
                  <span className="image-placeholder-text">
                    <FontAwesomeIcon
                      icon={["far", "upload"]}
                      className="image-placeholder-icon"
                    />
                    Drag & drop image files or
                    <span className="image-placeholder-style">browse</span> to
                    upload
                  </span>
                </div>
              ) : (
                <DropzoneFiles
                  className="imageformfield-dropzonefiles"
                  multiple={false}
                  onFilesAdded={this._onUploadImage}
                  toggleBrowse={this.props.replaceImage}
                  totalRowItems={this.props.totalRowItems}
                  checkImgUploadLoader={this.state.checkImgUploadLoader}
                  placeholder={this._getUploadImagePlaceholder()}
                  uploadImageTypeMessage="This file type is not supported. Try uploading .jpeg, .jpg or .png"
                />
              )}

              {/* --------- Image upload loader section --------- */}
              {this.state.loading && (
                <Loader
                  className="imageformfield-loader"
                  label="Uploading your image"
                />
              )}
            </div>
          )}
          {/* --------- Image upload error section --------- */}
          {this.state.errMsg && (
            <div className="error-message-wrapper imageformfield-error-message-wrapper">
              <span className="error-message-icon">
                <FontAwesomeIcon icon={["far", "times-circle"]} />
              </span>
              {this.state.errMsg}
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  forceUpdateEditorSectionIdAction,
};

export default connect(
  null,
  mapDispatchToProps,
)(ImageFormField);



// WEBPACK FOOTER //
// ./src/components/DocumentV2/FormView/FormModeComponents/ImageFormField.js